import { SR_API_ACTION_ADMIN_VALIDATE_PARTNER_SIGNUP } from 'api/actionTypes';

export default async function validatePartnerSignup(
  { state, apiClient },
  { partnerId, signupInvalid },
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_ADMIN_VALIDATE_PARTNER_SIGNUP,
    state: state,
    payload: {
      partnerId,
      signupInvalid,
    },
  });
}
